module.exports = __webpack_public_path__ + "static/formControl-96af2ecd380cd0b4daf4a82cb71714be.png";